webpackJsonp([49524051148731,141042188955504,89545996237120,45627166398967],{

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactCore = __webpack_require__(3);
	
	var _SimplePopover = __webpack_require__(166);
	
	var _SimplePopover2 = _interopRequireDefault(_SimplePopover);
	
	var _AdvancedPopover = __webpack_require__(164);
	
	var _AdvancedPopover2 = _interopRequireDefault(_AdvancedPopover);
	
	var _HeadlessPopover = __webpack_require__(165);
	
	var _HeadlessPopover2 = _interopRequireDefault(_HeadlessPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  title: 'Popover',
	  components: {
	    Popover: _reactCore.Popover
	  },
	  enumValues: {
	    'Object.keys(PopoverPosition).map(key => PopoverPosition[key])': Object.keys(_reactCore.PopoverPosition).map(function (key) {
	      return _reactCore.PopoverPosition[key];
	    })
	  },
	  examples: [{ component: _SimplePopover2.default, title: 'Simple Popover' }, { component: _AdvancedPopover2.default, title: 'Programmatically Controlled Popover' }, { component: _HeadlessPopover2.default, title: 'Headless Popover' }]
	};
	module.exports = exports['default'];

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdvancedPopover = function (_React$Component) {
	  _inherits(AdvancedPopover, _React$Component);
	
	  function AdvancedPopover(props) {
	    _classCallCheck(this, AdvancedPopover);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleClick = function () {
	      _this.setState({
	        show: !_this.state.show
	      });
	    };
	
	    _this.handleKeepInViewChange = function (checked) {
	      _this.setState({ keepInViewChecked: checked });
	    };
	
	    _this.handleProgrammaticChange = function (checked) {
	      _this.setState({
	        show: checked
	      });
	    };
	
	    _this.shouldClose = function (tip) {
	      _this.setState({ show: false });
	    };
	
	    _this.state = {
	      position: _reactCore.PopoverPosition.top,
	      show: false,
	      keepInViewChecked: true
	    };
	    return _this;
	  }
	
	  AdvancedPopover.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          { style: { paddingRight: '10px' } },
	          'Popover Position'
	        ),
	        _react2.default.createElement(
	          'select',
	          {
	            onChange: function onChange(event) {
	              _this2.setState({ position: event.target.value });
	            }
	          },
	          Object.keys(_reactCore.PopoverPosition).map(function (key) {
	            return _react2.default.createElement(
	              'option',
	              { key: key, value: _reactCore.PopoverPosition[key] },
	              _reactCore.PopoverPosition[key]
	            );
	          })
	        ),
	        _react2.default.createElement(_reactCore.Checkbox, {
	          label: 'Flip popover if the position falls outside the view',
	          isChecked: this.state.keepInViewChecked,
	          onChange: this.handleKeepInViewChange,
	          'aria-label': 'Keep in view',
	          id: 'check-3'
	        }),
	        _react2.default.createElement(_reactCore.Checkbox, {
	          label: 'Toggle popover from outside',
	          isChecked: this.state.show,
	          onChange: this.handleProgrammaticChange,
	          'aria-label': 'Toggle popover from outside',
	          id: 'check-4'
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { margin: '180px 0px 0px 270px' } },
	        _react2.default.createElement(
	          _reactCore.Popover,
	          {
	            position: this.state.position,
	            isVisible: this.state.show,
	            shouldClose: this.shouldClose,
	            enableFlip: this.state.keepInViewChecked,
	            appendTo: function appendTo() {
	              return document.getElementById('___gatsby');
	            },
	            headerContent: _react2.default.createElement(
	              'div',
	              null,
	              'Popover Header'
	            ),
	            bodyContent: _react2.default.createElement(
	              'div',
	              null,
	              'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam id feugiat augue, nec fringilla turpis.'
	            )
	          },
	          _react2.default.createElement(
	            _reactCore.Button,
	            { onClick: this.handleClick },
	            'Toggle Popover'
	          )
	        )
	      )
	    );
	  };
	
	  return AdvancedPopover;
	}(_react2.default.Component);
	
	exports.default = AdvancedPopover;
	AdvancedPopover.__docgenInfo = {
	  'description': '',
	  'displayName': 'AdvancedPopover'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 410:
/***/ (function(module, exports) {

	module.exports = "import React from 'react';\nimport { Popover, PopoverPosition, Checkbox, Button } from '@patternfly/react-core';\n\nclass AdvancedPopover extends React.Component {\n  constructor(props) {\n    super(props);\n    this.state = {\n      position: PopoverPosition.top,\n      show: false,\n      keepInViewChecked: true\n    };\n  }\n\n  handleClick = () => {\n    this.setState({\n      show: !this.state.show\n    });\n  };\n\n  handleKeepInViewChange = checked => {\n    this.setState({ keepInViewChecked: checked });\n  };\n\n  handleProgrammaticChange = checked => {\n    this.setState({\n      show: checked\n    });\n  };\n\n  shouldClose = tip => {\n    this.setState({ show: false });\n  };\n\n  render() {\n    return (\n      <div>\n        <div>\n          <span style={{ paddingRight: '10px' }}>Popover Position</span>\n          <select\n            onChange={event => {\n              this.setState({ position: event.target.value });\n            }}\n          >\n            {Object.keys(PopoverPosition).map(key => (\n              <option key={key} value={PopoverPosition[key]}>\n                {PopoverPosition[key]}\n              </option>\n            ))}\n          </select>\n          <Checkbox\n            label=\"Flip popover if the position falls outside the view\"\n            isChecked={this.state.keepInViewChecked}\n            onChange={this.handleKeepInViewChange}\n            aria-label=\"Keep in view\"\n            id=\"check-3\"\n          />\n          <Checkbox\n            label=\"Toggle popover from outside\"\n            isChecked={this.state.show}\n            onChange={this.handleProgrammaticChange}\n            aria-label=\"Toggle popover from outside\"\n            id=\"check-4\"\n          />\n        </div>\n\n        <div style={{ margin: '180px 0px 0px 270px' }}>\n          <Popover\n            position={this.state.position}\n            isVisible={this.state.show}\n            shouldClose={this.shouldClose}\n            enableFlip={this.state.keepInViewChecked}\n            appendTo={() => document.getElementById('___gatsby')}\n            headerContent={<div>Popover Header</div>}\n            bodyContent={\n              <div>\n                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam id feugiat augue, nec fringilla turpis.\n              </div>\n            }\n          >\n            <Button onClick={this.handleClick}>Toggle Popover</Button>\n          </Popover>\n        </div>\n      </div>\n    );\n  }\n}\n\nexport default AdvancedPopover;\n"

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeadlessPopover = function (_React$Component) {
	  _inherits(HeadlessPopover, _React$Component);
	
	  function HeadlessPopover() {
	    _classCallCheck(this, HeadlessPopover);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  HeadlessPopover.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactCore.Popover,
	      {
	        position: 'right',
	        bodyContent: _react2.default.createElement(
	          'div',
	          null,
	          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam id feugiat augue, nec fringilla turpis.'
	        ),
	        'aria-label': 'Headless Popover'
	      },
	      _react2.default.createElement(
	        _reactCore.Button,
	        null,
	        'Toggle Popover'
	      )
	    );
	  };
	
	  return HeadlessPopover;
	}(_react2.default.Component);
	
	exports.default = HeadlessPopover;
	HeadlessPopover.__docgenInfo = {
	  'description': '',
	  'displayName': 'HeadlessPopover'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 411:
/***/ (function(module, exports) {

	module.exports = "import React from 'react';\nimport { Popover, Button } from '@patternfly/react-core';\n\nclass HeadlessPopover extends React.Component {\n  render() {\n    return (\n      <Popover\n        position=\"right\"\n        bodyContent={\n          <div>\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam id feugiat augue, nec fringilla turpis.\n          </div>\n        }\n        aria-label=\"Headless Popover\"\n      >\n        <Button>Toggle Popover</Button>\n      </Popover>\n    );\n  }\n}\n\nexport default HeadlessPopover;\n"

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimplePopover = function (_React$Component) {
	  _inherits(SimplePopover, _React$Component);
	
	  function SimplePopover() {
	    _classCallCheck(this, SimplePopover);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SimplePopover.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactCore.Popover,
	      {
	        position: 'right',
	        headerContent: _react2.default.createElement(
	          'div',
	          null,
	          'Popover Header'
	        ),
	        bodyContent: _react2.default.createElement(
	          'div',
	          null,
	          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam id feugiat augue, nec fringilla turpis.'
	        )
	      },
	      _react2.default.createElement(
	        _reactCore.Button,
	        null,
	        'Toggle Popover'
	      )
	    );
	  };
	
	  return SimplePopover;
	}(_react2.default.Component);
	
	exports.default = SimplePopover;
	SimplePopover.__docgenInfo = {
	  'description': '',
	  'displayName': 'SimplePopover'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 412:
/***/ (function(module, exports) {

	module.exports = "import React from 'react';\nimport { Popover, Button } from '@patternfly/react-core';\n\nclass SimplePopover extends React.Component {\n  render() {\n    return (\n      <Popover\n        position=\"right\"\n        headerContent={<div>Popover Header</div>}\n        bodyContent={\n          <div>\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam id feugiat augue, nec fringilla turpis.\n          </div>\n        }\n      >\n        <Button>Toggle Popover</Button>\n      </Popover>\n    );\n  }\n}\n\nexport default SimplePopover;\n"

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.popover_package = exports.popover_docs = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopoverDocs = __webpack_require__(540);
	
	var _PopoverDocs2 = _interopRequireDefault(_PopoverDocs);
	
	var _componentDocs = __webpack_require__(15);
	
	var _componentDocs2 = _interopRequireDefault(_componentDocs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rawExamples = [{ name: 'AdvancedPopover', path: '../../react-core/src/components/Popover/examples/AdvancedPopover.js', file: __webpack_require__(410) }, { name: 'HeadlessPopover', path: '../../react-core/src/components/Popover/examples/HeadlessPopover.js', file: __webpack_require__(411) }, { name: 'SimplePopover', path: '../../react-core/src/components/Popover/examples/SimplePopover.js', file: __webpack_require__(412) }];
	var images = [{ name: 'img_avatar.svg', file: __webpack_require__(7) }, { name: 'l_pf-reverse-164x11.png', file: __webpack_require__(8) }, { name: 'pf_logo.svg', file: __webpack_require__(9) }, { name: 'pf_mini_logo_white.svg', file: __webpack_require__(10) }, { name: 'img_avatar.svg', file: __webpack_require__(12) }, { name: 'pf_logo.svg', file: __webpack_require__(13) }, { name: 'pf_logo_color.svg', file: __webpack_require__(14) }, { name: 'pfbg_992.jpg', file: __webpack_require__(11) }];
	
	var popover_docs = exports.popover_docs = _PopoverDocs2.default;
	var popover_package = exports.popover_package = 'react-core';
	
	exports.default = function () {
	    return _react2.default.createElement(_componentDocs2.default, _extends({ rawExamples: rawExamples, images: images }, _PopoverDocs2.default));
	};

/***/ })

});


// WEBPACK FOOTER //
// component---tmp-popover-docs-js-deddb08593c24b99faa4.js